import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { newTherapyTemplateAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  CREATE_NEW_THERAPY_TEMPLATE_REQUEST,
  CREATE_NEW_THERAPY_TEMPLATE_SUCCESS,
  CREATE_NEW_THERAPY_TEMPLATE_LOADING,
  CREATE_NEW_THERAPY_TEMPLATE_FAILURE,
} = newTherapyTemplateAction;

function* createNewTherapyTemplate(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: CREATE_NEW_THERAPY_TEMPLATE_LOADING });

    const reponse = yield call(therapyPlanningService.createNewTherapyTemplates, payload.payload);
    if (reponse?.status === 200) {
      yield put({
        type: CREATE_NEW_THERAPY_TEMPLATE_SUCCESS,
        payload: reponse?.data,
      });
    } else throw reponse.data;
  } catch (error) {
    yield put({ type: CREATE_NEW_THERAPY_TEMPLATE_FAILURE, payload: error });
  }
}

function* createNewTherapyTemplateSaga() {
  yield takeEvery(CREATE_NEW_THERAPY_TEMPLATE_REQUEST, createNewTherapyTemplate);
}

export default createNewTherapyTemplateSaga;
